import { Box, Flex, Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import { LabelPromo } from '@diamond/shared/ui';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import { CheckIconVoucher } from './Icons';

interface Props
  extends ColumnComponentProps<BackofficeActivitiesOrderItem, string> {
  isVoucherEnabled?: boolean;
}

export function ProductNameColumn({ info, isVoucherEnabled = false }: Props) {
  const item = info.row.original as BackofficeActivitiesOrderItem & {
    has_voucher_discount?: boolean;
    voucher_code?: string;
  };

  const hasVoucherDiscount = item.has_voucher_discount ?? false;
  const voucherCode = item.voucher_code;

  const isVoucherFreeGoodsRequirement = voucherCode && !hasVoucherDiscount;

  return (
    <Box>
      <Text mb="1" fontSize="sm" fontWeight="400" color="#373F41">{info.getValue()}</Text>
      <Flex gap="2" alignItems="center" flexWrap="wrap">
        {info.row.original.is_discount === true && (
          <LabelPromo type="discount" />
        )}
        {info.row.original.quantity_free_goods && (
          <LabelPromo type="free-item" isFreeGoods />
        )}

        {isVoucherEnabled &&
          (hasVoucherDiscount || isVoucherFreeGoodsRequirement) && (
            <CheckIconVoucher boxSize="20px" />
          )}

        {isVoucherEnabled && hasVoucherDiscount && (
          <LabelPromo type="discount" />
        )}
        {isVoucherEnabled && isVoucherFreeGoodsRequirement && (
          <Text fontSize="sm" fontWeight="400" color="red.500" fontStyle="italic">
            *Syarat produk gratis
          </Text>
        )}
      </Flex>
    </Box>
  );
}
